import React, {useState, useEffect} from 'react';
import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import Form from './components/Form/Form.js'
import {getPosts} from './actions/posts'
import Posts from './components/Posts/Posts.js'
import useStyles from './styles.js';
import {useDispatch} from 'react-redux';

import memories from './images/memories.png';
const App = () =>{
    const [currentID, setCurrentID] = useState(null);
    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() =>{
        dispatch(getPosts());
    }, [dispatch, currentID]);

    return(
        <Container maxwidth="lg">
            <AppBar className={classes.appBar} position="static" color="inherit" >
                <Typography className={classes.heading} variant="h2" align="center">Memories </Typography>
                <img className={classes.image} src={memories} alt="memories" height="60" width="60"/>
            </AppBar>
            <Grow in>
                <Container>
                    <Grid className={classes.mainContainer} container alignItems="stretch" spacing={3}>
                        <Grid item xs={12} sm={7}>
                            <Posts setCurrentID={setCurrentID}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Form currentID={currentID} setCurrentID={setCurrentID}/>
                        </Grid>
                    </Grid>
                </Container>
            </Grow>
        </Container>
    )
}

export default App